import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import player from 'lottie-web';
// import { LottieModule as NgxLottieModule } from 'ngx-lottie';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { MatCardModule } from '@angular/material/card';
// import { FadeComponentComponent } from './fade-component/fade-component.component';

import { BodyComponent } from './body/body.component';
import { CardsWrapComponent } from './cards-wrap/cards-wrap.component';
import { HeadingSmallComponentComponent } from './heading-small-component/heading-small-component.component';
import { LeadFormComponent } from './lead-form/lead-form.component';
import { LegalComponent } from './legal/legal.component';
import { NewFooterComponent } from './new-footer/new-footer.component';
import { NewHeaderComponent } from './new-header/new-header.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { ShimmerUiComponent } from './shimmer-ui/shimmer-ui.component';
import { SitemapComponent } from './sitemap/sitemap.component';
import { TermsComponent } from './terms/terms.component';
import { WeDoComponent } from './we-do/we-do.component';
import { AppJobModule } from '../app-job/app-job.module';
import { NgxMarqueeComponent } from '@omnedia/ngx-marquee';
import { NgxTimelineComponent } from '@omnedia/ngx-timeline';
import { NgxFadeComponent } from '@omnedia/ngx-fade';
import { NgxGradientTextComponent } from '@omnedia/ngx-gradient-text';

export function playerFactory() {
  return player;
}

@NgModule({
  declarations: [
    BodyComponent,
    CardsWrapComponent,
    HeadingSmallComponentComponent,
    LeadFormComponent,
    LegalComponent,
    NewFooterComponent,
    NewHeaderComponent,
    PrivacyComponent,
    ShimmerUiComponent,
    SitemapComponent,
    TermsComponent,
    WeDoComponent,
    // FadeComponentComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    MatSnackBarModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatToolbarModule,
    MatGridListModule,
    MatSelectModule,
    MatCardModule,
    NgxMarqueeComponent,
    NgxTimelineComponent,
    NgxFadeComponent,
    NgxGradientTextComponent,
  ],
  exports: [
    BodyComponent,
    CardsWrapComponent,
    HeadingSmallComponentComponent,
    LeadFormComponent,
    LegalComponent,
    RouterModule,
    NewFooterComponent,
    NewHeaderComponent,
    PrivacyComponent,
    ShimmerUiComponent,
    SitemapComponent,
    TermsComponent,
    WeDoComponent,
    FormsModule,
    MatSnackBarModule,
    // NgxLottieModule.forRoot({ player: playerFactory }),
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatRadioModule,
    MatToolbarModule,
    MatGridListModule,
    MatSelectModule,
    MatCardModule,
    // FadeComponentComponent,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SharedModule {}
